module.exports = __webpack_public_path__ + "static/img_2507-3bf602761da7e2427dd3f7f4102a91a2.webp";